import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import InfoIcon from '@mui/icons-material/Info';
import { Stack, Switch, Tooltip, Typography } from '@mui/material';

import { alertRulesActions, alertRulesSelectors } from 'app-components/flux/alert-rules';
import { tracker } from 'app-components/utils/core';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { useFetchOnce } from 'app-components/hooks/utils';

import SettingsHeader from 'containers/Settings/SharedComponents/SettingsHeader';
import { useAppSelector } from 'hooks/redux';
import { useDispatch } from 'react-redux';
import NotificationRowSetting from './notificationRowSetting';
import NotificationRowSettingLegacy from './notificationRowSettingLEGACY';

import NotificationsImage from 'assets/illustrations/Notifications-blue.svg';

const useStyles = makeStyles()((theme) => ({
  flatCard: {
    padding: theme.spacing(3),
    paddingTop: 0,
  },
  legacyFlatCard: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  pauseAll: {
    backgroundColor: theme.palette.success.light,
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    flexGrow: 1,
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  topSection: {
    padding: theme.spacing(3),
    paddingBottom: 0,
  },
  infoIcon: {
    color: theme.palette.icon.light,
    marginLeft: 8,
    height: 16,
    width: 16,
  },
  headerContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: 16,
  },
  emailCentering: {
    marginLeft: 0,
  },
  pushCentering: {
    marginLeft: -25,
  },
}));

function Notifications() {
  const { classes, cx } = useStyles();
  const dispatch = useDispatch();

  useFetchOnce(alertRulesActions.getAlertRules, alertRulesSelectors, false);
  const isAlertPaused = useAppSelector(alertRulesSelectors.alertRulesPaused);

  const alertRules = useAppSelector(alertRulesSelectors.getAllAlertRulesSorted); // unnecesarry rerenders, perhaps redux debugging needed
  const notificationsv2 = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'notificationsV2'));
  return (
    <Grid container direction='column'>
      <SettingsHeader title='Notifications' />
      <Paper variant='outlined'>
        {notificationsv2 ? (
          <div className={classes.topSection}>
            <div className={classes.pauseAll}>
              <Stack direction='row' gap={2} alignItems='center'>
                <img
                  src={NotificationsImage}
                  alt='notifications-bell'
                  style={{ width: 64, height: 64, marginRight: 16 }}
                />
                <div>
                  <Typography variant='titleMedium'>Pause all notifications</Typography>
                  <Typography variant='paragraphRegular'>Take a break, pause all notifications.</Typography>
                </div>
              </Stack>
              <Switch
                size='small'
                color='primary'
                checked={isAlertPaused}
                onChange={(value) => {
                  dispatch(alertRulesActions.pauseAlertRules(value.target.checked));
                  tracker.track(tracker.events.alertRules, {
                    type: 'ALL',
                    title: 'All notifications',
                    state: value.target.checked ? 'disabled' : 'enabled',
                  });
                }}
              />
            </div>
            <div className={classes.title}>
              <Typography variant='titleMedium'>Customize</Typography>
              <Tooltip title='Blank chips indicate the notification is not available'>
                <InfoIcon className={classes.infoIcon} />
              </Tooltip>
            </div>
          </div>
        ) : null}
        <Grid
          className={cx(classes.flatCard, !notificationsv2 ? classes.legacyFlatCard : '')}
          container
          justifyContent='space-between'
          alignItems='flex-start'
        >
          {!notificationsv2 ? (
            <Grid container className={classes.headerContainer}>
              <Grid item md={7} sm={7} />
              <Grid item md={2} sm={2} xs={6}>
                <Typography className={classes.emailCentering}>Email</Typography>
              </Grid>
              <Grid item md={2} sm={2} xs={6}>
                <Typography className={classes.pushCentering}>Push (Mobile)</Typography>
              </Grid>
            </Grid>
          ) : null}
          {alertRules
            .valueSeq()
            .map((alertRule) =>
              notificationsv2 ? (
                <NotificationRowSetting key={alertRule.id} alertRule={alertRule} isAllPaused={isAlertPaused} />
              ) : (
                <NotificationRowSettingLegacy
                  key={alertRule.id}
                  title={alertRule.title}
                  firstSwitchBool={alertRule.preferences.isEmailOk}
                  secondSwitchBool={alertRule.preferences.isPushOk}
                  alertRule={alertRule}
                />
              ),
            )}
        </Grid>
      </Paper>
    </Grid>
  );
}

export default Notifications;
